import fetchival from 'fetchival';
import config from '../../config/config';

const Base = fetchival(config.API_BASE_URL);

class SystemApi {
  static warmup() {
    return Base.get();
  }
}

export default SystemApi;



// WEBPACK FOOTER //
// ./src/api/system/systemApi.js